import Button from '@mui/material/Button'
import EditIcon from '@mui/icons-material/Edit';
import {
    Box,
    Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { SelectGenericFromTable } from '../universal/Axios';
import EditComparativeSetDescriptionModal from './EditComparativeSetDescriptionModal';
import { ComparativeSetResultsTable } from './ComparativeSetResultsTable';
import { SignalNoiseSeparationInputTable } from './SignalNoiseSeparationInputTable';

const EditComparativeSet = () => {
    const queryParameters = new URLSearchParams(window.location.search)
    const id = queryParameters.get("id")
    const [editComparativeSetModalOpen, setEditComparativeSetModalOpen] = useState(false)
    const [comparativeSetDescription, setComparativeSetDescription] = useState("")
    const [comparativeSetDescriptionObject, setComparativeSetDescriptionObject] = useState("")
    const [isCompareDNCsButtonDisabled, setIsCompareDNCsButtonDisabled] = useState(true)
    const [selectedDensityNetworkConfigIDs, selectDensityNetworkConfigID] = useState([]);

    useEffect(() => {
        SelectGenericFromTable("select description from comparative_set where id = '" + id + "';", setComparativeSetDescriptionObject)
    }, [editComparativeSetModalOpen, id]);
    useEffect(() => {
        setComparativeSetDescription(comparativeSetDescriptionObject[0]?.description)
    }, [comparativeSetDescriptionObject]);

    useEffect(() => {
        if (selectedDensityNetworkConfigIDs.length > 1) {
            setIsCompareDNCsButtonDisabled(false)
        }
        else {
            setIsCompareDNCsButtonDisabled(true)
        }
    }, [selectedDensityNetworkConfigIDs]);

    return (
        <Box>
            <Box sx={{ justifyContent: "space-between", display: "flex" }}>
            <Typography variant="h6">{id}</Typography>
            <Box >
                <Button
                    variant="contained"
                    href="#"
                    onClick={() => setEditComparativeSetModalOpen(true)}
                >
                    Edit
                </Button>
                <Button
                    variant="contained"
                        href={"comparative-set-density-network-config-results?comparative-set=" + id + "&density-network-config-ids=" + selectedDensityNetworkConfigIDs.join(";")}
                    sx={{ marginLeft: '20px', textTransform: 'none' }}
                    disabled={isCompareDNCsButtonDisabled}
                >
                    COMPARE DNCs
                </Button>
            </Box>
            </Box>
            <div style={{ height: '55px' }}>
            <b>Description:</b> {comparativeSetDescription}
            </div>
            <b>Linked Density Network Configs</b>
            <div style={{ height: '450px', width: '100%', marginBottom: 16 }}>
                <ComparativeSetResultsTable id={id} selectedDensityNetworkConfigIDs={selectedDensityNetworkConfigIDs} selectDensityNetworkConfigID={selectDensityNetworkConfigID} />
            </div>
            <b>Component Signal Noise Separation Inputs</b>
            <div style={{ height: '500px', width: '100%', marginBottom: 16 }}>
                <SignalNoiseSeparationInputTable comparativeSetID={id} selectionEnabled={false} />
            </div>
            <EditComparativeSetDescriptionModal
                open={editComparativeSetModalOpen}
                setClose={() => setEditComparativeSetModalOpen(false)}
                comparative_set_id={id}
                current_description={comparativeSetDescription}
            />
        </Box>
    )
}

export default EditComparativeSet